<template>
  <div>
    <!-- 移动端头部 -->
    <div class="phoneHead">
      <div class="back" @click="goBack">
        <img src="../../assets/img/phoneBack.png" alt="" />
        <div @click="goStudy" class="goStudy">返回学习中心</div>
      </div>
      <div class="texs">视频播放</div>
      <div class="back"></div>
    </div>

    <div class="videoBanner" style="position: absolute; top: 0; width: 100%; height: 100%; background: #000000">
      <div class="videoHeader">
        <div class="backBox" @click="goBack">
          <div style="display: flex">
            <img src="../../assets/img/back_icon.png" alt="" />
          </div>
          <div class="back_text">返回课程页</div>
        </div>
        <div class="courseText">{{ videoInfo.cwName || '' }}</div>
      </div>

      <div class="bannerBox">
        <div>
          <div class="videoBox" style="position: relative">
            <div v-show="!ccShow" ref="player" class="videoBox" id="videoPlayer1" @ended="endVideo()" @timeupdate="timeupdate"></div>
            <div v-show="ccShow" style="  width: 1460px !important;
      height: 630px !important;" class="videobox" id="videoPlayer2"></div>
            <!-- <img
              style="position: absolute; top: 10px; right: 30px; z-index: 99999; width: 102px; height: 31px"
              src="../../assets/img/videoLogo.png"
              alt=""
            /> -->
          </div>

          <div style="display: flex;">
            <div :class="bmShow ? 'tips' : 'tips tipsShow'" >
              <div class="tipsTitle">
                温馨提示
                <!-- <div></div> -->
              </div>

              <div style="display: flex">
                <div style="display: flex">
                  <div>
                    <div class="margin25">1.请到“账号管理”界面完善个人信息，这将有利于为您快速登记学时证明；</div>
                    <div class="margin25">2.推荐使用360浏览器极速模式进行学习；</div>
                    <div class="margin25">3.课程学习通过后可到学习中心“我的班级”界面自主打印学时证明；</div>
                    <div class="margin25">4.如您需要发票请到“订单管理”界面点击“申请开票”，输入发票信息，申领电子发票;</div>
                    <div class="margin25">5.所报名班级下的所有课程全部学习完成才能生成证书。</div>
                  
                  </div>

                  <div
                  v-if="isExam.isExam == '02'"
                    style="
                      color: #fff;
                      cursor: pointer;
                      width: 120px;
                      height: 40px;
                      background: #438ce7;
                      opacity: 1;
                      border-radius: 6px;
                      text-align: center;
                      line-height: 40px;
                      margin-top: 50px;
                    "
                    @click="goExam"
                  >
                    参加考试
                  </div>
                </div>
              </div>
            </div>

            <div class="bm" v-if="bmShow">
              <div class="b1">温馨提示</div>
              <div class="b2">{{ bmText }}前往继续教育专区选课购买。</div>
              
              <div class="b3">
                <div></div>
                <div class="b4" @click="goBm">立即前往报名</div>
              </div>
            </div>
          </div>
        </div>

        <div class="directory">
          <div class="tipsTitle">
            目录
            <div></div>
          </div>

          <div v-for="item in chapterList" :key="item.id">
            <div class="listBox_1" @click="seletZan(item)" :key="zanKey">
              <div class="ml8 fs18" :title="item.cname">{{ item.cname }}</div>
              <div class="mar38">
                <img class="mrw16" v-if="item.zan" src="../../assets/indexImg/bottom_Icon.png" alt="" />
                <img class="mrw16" v-else src="../../assets/indexImg/left_Icon.png" alt="" />
              </div>
            </div>
            <div v-show="item.zan" :key="zanKey1">
              <div class="listBox_1" style="margin-top: 0" v-for="data in item.chapterList" :key="data.id" @click="videoChange(data, 1)">
                <div style="display: flex; align-items: center" v-if="videoInfo.chapterId == data.chapterId">
                  <div class="play">播放中</div>
                </div>

                <div :class="videoInfo.chapterId == data.chapterId ? 'ml8 sColor' : 'ml8'" :title="data.cwName">{{ data.cwName }}</div>
                <div :class="videoInfo.chapterId == data.chapterId ? 'mar38 sColor' : 'mar38'">{{ data.jinDu }}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="phoneBanner">
      <div class="videobox">
        
      </div>

      <div class="chapterName">
        <div>
          {{ videoInfo.cwName || '' }}
        </div>

        <div class="t_1">总学时：{{ videoInfo.creditnum }}学时</div>
      </div>
      <div class="bgc"></div>

      <div class="chapterList">
        <!-- tab栏 -->
        <div class="tabBox">
          <div :class="className == 1 ? 'to active' : 'to'" @click="navTab(1)">章节目录</div>

          <div :class="className == 2 ? ' xu to active' : ' xu to'" @click="navTab(2)">学习须知</div>
        </div>

        <div v-if="className == 1">
          <div v-for="item in chapterList" :key="item.id" class="chapter">
            <div class="titleText">课程名：{{ item.cname }}</div>

            <div class="botBox">
              <!-- <div class="xue">
                总学时：{{ item.hasCredit }}学时
              </div> -->
            </div>
            <div
              :class="videoInfo.chapterId == data.chapterId ? 'chapter chapterActive' : 'chapter'"
              v-for="data in item.chapterList"
              :key="data.id"
            >
              <div @click="videoChange(data, 2)" class="chaptList">
                <div class="cwName">{{ data.cwName }}</div>
                <div>{{ data.jinDu }}%</div>
              </div>
            </div>
          </div>
        </div>

        <div class="xuzhi" v-if="className == 2">
          <p>1.请到“账号管理”界面完善个人信息，这将有利于为您快速登记学时证明；</p>

          <p>2.推荐使用360浏览器极速模式进行学习；</p>

          <p>3.课程学习通过后可到学习中心“继续教育”界面自主打印学时证明；</p>

          <p>4.如您需要发票请到“订单管理”界面点击“申请开票”，输入发票信息，申领电子发票;</p>
          <p>5.所报名班级下的所有课程全部学习完成才能生成证书;</p>
        </div>
      </div>
    </div>

    <el-dialog
      title="温馨提示"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <p>请输入计算结果</p>
      <div style="display: flex; justify-content: center">
        <div>
          <div>
            <img style="width: 100px; height: 50px" :src="codeImg" alt="" />
            <div>
              <el-input style="width: 100px" v-model="codeNum"></el-input>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="codeSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// import Videojs from 'video.js';
// import 'videojs-contrib-hls';
import 'xgplayer';
import hlsjsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer';
import {
  toStudy,
  updateDBTrack,
  toStudyMain,
  getUrl,
  getTrainSupervision,
  sendCodeAnswer,
  getTmVerCode,
  toCheckGxkStudy,
  toAllReadyBuy
} from '../../api/questions';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      TMvalid: false, //是否需要验证码，false不需要
      dialogVisible: false, //验证码弹框
      codeNum: '', //验证码结果
      configKey: '', //tm平台需要的key
      codeImg: '', //验证码图片
      codeId: '', //提交验证码必要参数
      chapterid: '', //提交验证码必要参数
      tmId: '', //提交验证码必要参数
      coursePlayTimeList: [],
      isNeedVerify: '', //是否需要验证
      codeResTime: '', //验证时间
      codeIndex: '',
      userId: '',
      getVerCodeTime: 1, //1分钟
      everyProVideo: 15, //假定视频总长度
      isVerify_0: false, //
      verifyChapter: '',
      verCodeCount: 0,
      codeStatus: false, //验证码检查状态
      isGetTmVerCodeByVideoPlayTimer: null, //定时器
      options: {
        autoplay: true, // 设置自动播放
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        preload: 'auto', // 预加载
        controls: true // 显示播放的控件
      },
      player: null,
      queryPams: {},
      chapterList: [], //目录
      videoInfo: {}, //当前播放数据
      lessonstatus: '', //学习状态0
      videoTime: 0,
      timer: null,
      allInt: false, //视频是否已完成 false未完成 true已完成
      className: '1',
      t: false, //是pc还是移动端
      jinDuId: '', //动态渲染当前播放视频进度
      foj: '', //进度
      isExam: '',
      zanKey: 0, //
      zanKey1: 1000, //
      bmShow:false,
      bmText:'',
      ccShow:false,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goBm() {
       window.location.replace('https://www.ahsjxjy.com/lsitFs'+'?token='+ localStorage.getItem('token')+'&fCodeNo=0702');
    },
    toAllReadyBuy() {
      toAllReadyBuy().then(res => {
        if (res.data.data.msg == '') {
          this.bmShow = false
        }else {
           this.bmShow = true
        }
        this.bmText = res.data.data.msg
      })
    },
    //展开收起
    seletZan(item) {
      item.zan = !item.zan;
      console.log(item);
      this.zanKey = this.zanKey + 1;
      this.zanKey1 = this.zanKey1 + 10;
    },
    //提交验证码
    codeSubmit() {
      let data = {
        chapterId: this.chapterid,
        codeId: this.codeId,
        codeAnswer: this.codeNum,
        tmId: this.tmId
      };
      sendCodeAnswer(data).then(res => {
        console.log(res);
        //成功后关闭弹框
        if (res.data.data.data.verifyResult == '1') {
          this.dialogVisible = false;
          this.player.play();
        } else {
          this.dialogVisible = false;
          this.$message('回答错误！请重新验证');
          this.getTmVerCode(this.codeResTime);
        }
      });
    },
    //获取公需课平台验证数据
    getTrainSupervision() {
      if (this.TMvalid) {
        getTrainSupervision({ userId: this.userId, courseId: this.$route.query.courseId, classId: this.$route.query.classId }).then(tim => {
          if (tim.data.data.isNeedVerify == '00') {
            return false;
          }
          tim.data.data.data = JSON.parse(tim.data.data.data);
          this.coursePlayTimeList = tim.data.data.data.coursePlayTimeList;
          console.log('this.coursePlayTimeList', this.coursePlayTimeList);
          this.tmId = tim.data.data.tmId;
          this.configKey = tim.data.data.data.configKey;
          this.isNeedVerify = tim.data.data.isNeedVerify;
          this.verifyChapter = tim.data.data.verifyChapter;
          if (tim.data.data.error !== '') {
            this.$message('系统异常！');
            this.goBack();
          } else if (tim.data.data.isNeedVerify == '01' && this.verifyChapter.indexOf(this.chapterid) == -1) {
            this.initGetTmVerCode();
          }
        });
      }
    },
    goExam() {
      window.location.replace(this.isExam.quizUrl + '&token=' + localStorage.getItem('token'));
    },
    goStudy() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      getUrl().then(res => {
        if (isMobile) {
          window.location.replace(res.data.data.mobileCenterUrl + '?token=' + localStorage.getItem('token'));
        } else {
          window.location.replace(res.data.data.pcCenterUrl + '?token=' + localStorage.getItem('token'));
        }
      });
    },
    toShow(index) {
      this.t = index;
    },
    navTab(id) {
      this.className = id;
    },
    initGetTmVerCode() {
      //需要验证
      //需要验证
      this.coursePlayTimeList.forEach(coursePlayTime => {
        if (coursePlayTime.isVerify == 0) {
          setTimeout(() => {
            this.isVerify_0 = true;
            this.getTmVerCode(coursePlayTime.playTime);
          }, 1000 * 60 * this.getVerCodeTime);
        }
        return;
      });

      if (this.isVerify_0) {
        return;
      }
      this.isGetTmVerCodeByVideoPlayTimer = setInterval(() => {
        console.log(Math.floor(this.player.currentTime));
        //没有规定时间的情况,需自己计算时间传给后端
        if (Math.floor(this.player.currentTime) == this.getVerCodeTime * 60) {
          clearInterval(this.isGetTmVerCodeByVideoPlayTimer);
          //已经成功验证过第几次  从已经验证的章节列表获取
          if (this.verifyChapter == '') {
            //未验证通过过
            this.verCodeCount = 0;
          } else {
            this.verCodeCount = this.verifyChapter.split('_').length;
          }

          //playTime 课程播放时间，单位:秒，如：课程进度在 2401 秒弹出验证码
          var playTime = this.verCodeCount * this.everyProVideo * 60 + this.getVerCodeTime * 60;

          this.getTmVerCode(playTime);
        }
      }, 1000);
    },

    goBack() {
      this.$router.back();
      // this.$router.push({ path: '/pattern', query: { classId:this.$route.query.classId, id: this.queryPams.courseId, courseWareId: this.queryPams.coursewareId } });
    },
    timeupdate(e) {
      if (this.allInt) {
        return false;
      }
      this.videoTime = this.videoTime + 0.25;
      if (this.player.currentTime - (this.videoInfo.chapterhours + this.videoTime) > 10) {
        this.player.currentTime = this.videoInfo.chapterhours + this.videoTime;
      }
    },
    //视频结束事件
    endVideo(t) {
      if (this.allInt) {
        let info = this.videoInfo.isFinal;
        let chapterId = this.videoInfo.chapterId;
        if (info == '1') {
          if (this.videoInfo.nextChapterId == '0') {
            return false;
          }
          //该视频是当前章节的最后一个,那么就重新调用接口,访问下一个。
          this.queryPams.classId = this.$route.query.classId;
          this.queryPams.courseId = this.videoInfo.nextCourseId;
          this.queryPams.coursewareId = this.videoInfo.nextCwId;
          this.queryPams.chapterId = this.videoInfo.nextChapterId;
          toStudy(this.queryPams).then(res => {
            if (res.data.data.chapter.lessonstatus == 'completed') {
              this.allInt = true;
            } else {
              this.allInt = false;
            }
            this.videoInfo = res.data.data.chapter;
            this.getVideo(this.videoInfo, t);
          });
          // toStudyMain(this.queryPams).then(res => {
          //   this.chapterList = res.data.data.courseList;
          //   this.chapterList.forEach(item => {
          //     if (item.chapterhours) {
          //       item.resLos = parseInt((item.chapterhours / item.period) * 100) + '%';
          //     } else {
          //       item.resLos = '未学习';
          //     }
          //   });
          // });
        } else {
          //如果不是最后一个，就正常播放下一个视频
          this.chapterList.forEach((item, index) => {
            item.zan = false; //关闭其他
            item.chapterList.forEach((msg, idx) => {
              if (msg.chapterId == chapterId) {
                item.zan = true; //打开正在播放的
                if (msg.lessonstatus == 'completed') {
                  msg.jinDu = 100;
                } else {
                  let time = this.player.currentTime;
                  msg.jinDu = parseInt((time / msg.period) * 100);
                }
                this.videoChange(this.chapterList[index].chapterList[idx + 1], t);
              }
            });
            if (item.chapterId == chapterId) {
            }
          });
        }
        return false;
      }
      if (this.videoInfo.period - Math.round(this.player.currentTime) <= 60) {
        this.lessonstatus = 'completed';
      } else {
        this.lessonstatus = 'incomplete';
      }
      console.log('this.videoInfo: ', this.videoInfo);
      var position = Math.round(this.player.currentTime), //当前视频播放时长
        duration = this.videoInfo.period, //章节总时长
        courseId = this.queryPams.courseId, //课程id
        coursewareId = this.videoInfo.cwId, //课件id
        chapterId = this.videoInfo.chapterId, //章节id
        trackMode = this.videoInfo.cwScorm, //视频跟踪类型（01按时间点跟踪、02按知识点跟踪）
        lessonstatus = this.lessonstatus, //学习状态
        classId = this.queryPams.classId;
      let cwPeriod = this.videoInfo.cwPeriod;
      let creditnum = this.videoInfo.creditnum;
      let period = this.videoInfo.period;
      // lessonLocation = this.dataMsg.lessonLocation, //当前章节时长
      // suspendData = this.dataMsg.suspendData,
      let flag = '0'; //是否为老学员，默认0
      if (this.ccShow) {
        position = Math.round(this.player.getPosition());//如果是cc
      } else {
        position = Math.round(this.player.currentTime);
      }

      var params = {
        position: position,
        duration: duration,
        courseId: courseId,
        coursewareId: coursewareId,
        chapterId: chapterId,
        trackMode: trackMode,
        lessonstatus: lessonstatus,
        classId: classId,
        // lessonLocation: lessonLocation,
        // suspendData: suspendData,
        flag: flag,
        cwPeriod: cwPeriod,
        creditnum: creditnum,
        period: period
      };
      updateDBTrack(params).then(res => {
        let info = this.videoInfo.isFinal;
        let chapterId = this.videoInfo.chapterId;
        if (info == '1') {
          if (this.videoInfo.nextChapterId == '0') {
            return false;
          }
          //该视频是当前章节的最后一个,那么就重新调用接口,访问下一个。
          this.queryPams.classId = this.$route.query.classId;
          this.queryPams.courseId = this.videoInfo.nextCourseId;
          this.queryPams.coursewareId = this.videoInfo.nextCwId;
          this.queryPams.chapterId = this.videoInfo.nextChapterId;
          toStudy(this.queryPams).then(res => {
            if (res.data.data.chapter.lessonstatus == 'completed') {
              this.allInt = true;
            } else {
              this.allInt = false;
            }
            this.videoInfo = res.data.data.chapter;
            this.getVideo(this.videoInfo, t);
          });
          toStudyMain(this.queryPams).then(res => {
            if (res.data.data.isSpot == '01') {
              this.$message('您还未报名公需课，请先报名再来学习！');
              window.open(res.data.data.TmUrl);
              return false;
            }

            this.chapterList = res.data.data.courseList;
            this.chapterList.forEach(item => {
              if (item.chapterhours) {
                item.resLos = parseInt((item.chapterhours / item.period) * 100) + '%';
              } else {
                item.resLos = '未学习';
              }
            });
          });
        } else {
          //如果不是最后一个，就正常播放下一个视频
          this.chapterList.forEach((item, index) => {
            item.chapterList.forEach((msg, idx) => {
              if (msg.chapterId == chapterId) {
                console.log(index, idx);
                let time = this.player.currentTime;
                msg.jinDu = parseInt((time / item.period) * 100);
                this.videoChange(this.chapterList[index].chapterList[idx + 1], t);
              }
            });
            if (item.chapterId == chapterId) {
            }
          });
        }
      });
      console.log('结束');
    },
    //两分钟记录一下时长
    updateDBTrack() {
      if (this.allInt) {
        return false;
      }
      if (this.videoInfo.period - Math.round(this.player.currentTime) <= 120) {
        this.lessonstatus = 'completed';
      } else {
        this.lessonstatus = 'incomplete';
      }
      var position = Math.round(this.player.currentTime), //当前视频播放时长
        duration = this.videoInfo.period, //章节总时长
        courseId = this.queryPams.courseId, //课程id
        coursewareId = this.videoInfo.cwId, //课件id
        chapterId = this.videoInfo.chapterId, //章节id
        trackMode = this.videoInfo.cwScorm, //视频跟踪类型（01按时间点跟踪、02按知识点跟踪）
        lessonstatus = this.lessonstatus, //学习状态
        classId = this.queryPams.classId;
      let cwPeriod = this.videoInfo.cwPeriod;
      let creditnum = this.videoInfo.creditnum;
      let period = this.videoInfo.period;
      // lessonLocation = this.dataMsg.lessonLocation, //当前章节时长
      // suspendData = this.dataMsg.suspendData,
      let flag = '0'; //是否为老学员，默认0
      if (this.ccShow) {
        position = Math.round(this.player.getPosition());//如果是cc
      } else {
        position = Math.round(this.player.currentTime);
      }

      var params = {
        position: position,
        duration: duration,
        courseId: courseId,
        coursewareId: coursewareId,
        chapterId: chapterId,
        trackMode: trackMode,
        lessonstatus: lessonstatus,
        classId: classId,
        // lessonLocation: lessonLocation,
        // suspendData: suspendData,
        flag: flag,
        cwPeriod: cwPeriod,
        creditnum: creditnum,
        period: period
      };
      updateDBTrack(params).then(res => {
        let info = this.videoInfo.chapterId;

        this.chapterList.forEach(item => {
          item.chapterList.forEach(v => {
            if (v.chapterId == info) {
              v.jinDu = Math.round(res.data.data.jindu);
              console.log(v);
            }
          });
        });
      });
    },
    videoChange(item, t) {
      this.updateDBTrack();
      // this.videoInfo = item
      // this.getVideo(item.launch)
      this.queryPams.classId = this.$route.query.classId;
      this.queryPams.courseId = item.courseId;
      this.queryPams.coursewareId = item.cwId;
      this.queryPams.chapterId = item.chapterId;
      toStudy(this.queryPams).then(res => {
        if (res.data.data.chapter.lessonstatus == 'completed') {
          this.allInt = true;
        } else {
          this.allInt = false;
        }
        this.videoInfo = res.data.data.chapter;
        this.getVideo(this.videoInfo, t);
        window.scrollTo(0, 0);
      });
      // toStudyMain(this.queryPams).then(res => {
      //   console.log(res);
      //   this.chapterList = res.data.data.courseList;
      //   this.chapterList.forEach(item => {
      //     if (item.chapterhours) {
      //       item.resLos = parseInt((item.chapterhours / item.period) * 100) + '%';
      //     } else {
      //       item.resLos = '未学习';
      //     }
      //   });
      // });
    },
    getData(t) {
      this.queryPams.classId = this.$route.query.classId;
      this.queryPams.courseId = this.$route.query.courseId;
      this.queryPams.coursewareId = this.$route.query.courseWareId;
      this.queryPams.chapterId = '';
      this.isExam = '02';
      toStudy(this.queryPams).then(res => {
        this.chapterid = res.data.data.chapter.chapterId;
        this.TMvalid = res.data.data.TMvalid;
        this.userId = res.data.data.userId;
        //this.getTrainSupervision();
        if (res.data.data.chapter.lessonstatus == 'completed') {
          this.allInt = true;
        } else {
          this.allInt = false;
        }
        this.videoInfo = res.data.data.chapter;
        this.gettToStudyMain();
        this.getVideo(this.videoInfo, t);
      });
    },
    gettToStudyMain() {
      toStudyMain(this.queryPams).then(res => {
        this.chapterList = res.data.data.courseList;
        this.chapterList.forEach(v => {
          v.zan = false;
          v.chapterList.forEach(x => {
            if (x.chapterId == this.videoInfo.chapterId) {
              v.zan = true;
              return false;
            }
          });
        });
      });
    },
    getVideo(videoUrl, t) {
      console.log(videoUrl, 'ssss');
       if (videoUrl.viewId !== '' && videoUrl.viewId !== null) {
        this.ccShow = true;
        //是cc视频的,清空西瓜
        // this.player.destroy('videoPlayer1');
        let elems = document.getElementById('videoPlayer2');
        let data = {
          vid: videoUrl.viewId,
          siteid: videoUrl.stateId,
          autoStart: true,
          // realAutoPlay:true,
          parentNode: elems,
          rate_allow_change: false,
          progressbar_enable: 0, //0禁止拖动，1可以拖动
          closeHistoryTime: 1,
          watchStartTime: 0, //断点续播
          showFullScreenBtn: false //禁止全屏
        };
        if (videoUrl.jindu >= 100) {
          //该视频已经播放完毕了
          data.progressbar_enable = 1;
          data.watchStartTime = 0;
        } else {
          data.progressbar_enable = 0;
          data.watchStartTime = videoUrl.hours;
        }
        this.player = createCCH5Player(data);
        setTimeout(() => {
          this.player.play();
        }, 1000);
        return false;
      }

      if (this.player !== null) {
        this.ccShow = false;

        this.player.destroy('videoPlayer' + t);
      }
      let ignores = [];
      // this.player = Videojs('videoPlayer' + t, this.options);
      //中经网一路学的课程
      if (videoUrl.sourceVideo == '01' || videoUrl.sourceVideo == '02') {
        if (t == 2) {
          ignores = ['fullscreen'];
        }
        this.player = new Player({
          id: 'videoPlayer' + t,
          autoplay: true,
          playsinline: true,
          url: videoUrl.launch
        });
      } else {
        //判断视频源是否是m3u8的格式
        //正常课程
        if (/\.m3u8$/.test(videoUrl.launch)) {
          let ignores = [];
          if (t == 2) {
            ignores = ['fullscreen'];
          }
          //判断视频源是否是m3u8的格式
          this.player = new hlsjsPlayer({
            id: 'videoPlayer' + t,
            autoplay: true,
            playsinline: true,
            url: videoUrl.launch,
            ignores: ignores
          });
        } else {
          let url = videoUrl.launch + '.mp4';
          let ignores = [];
          if (t == 2) {
            ignores = ['fullscreen'];
          }
          this.player = new Player({
            el: document.getElementById('videoPlayer' + t),
            autoplay: true,
            playsinline: true,
            url: url,
            ignores: ignores
          });
        }
      }
      if (this.videoInfo.lessonstatus == 'completed') {
        this.player.currentTime = 0;
      } else {
        document.getElementsByClassName('xgplayer-progress')[0].style = 'pointer-events:none';
        this.player.currentTime = this.videoInfo.chapterhours;
      }
      this.player.play();
      // this.player.on('loadstart', function () {});
      // this.player.on('progress', function () {});
      // this.player.on('loadedmetadata', function () {});
      // this.player.on('canplaythrough', function () {});
      // this.player.on('waiting', function () {});
      // this.player.on('play', function () {});
      // this.player.on('playing', function () {});
      // this.player.on('pause', function () {});
      let _this = this;
      // _this.player.play();
      _this.player.on('ended', function () {
        _this.endVideo(t);
      });
      // this.player.on('error', function () {});
      // this.player.on('currentTime', function () {});
      // this.player.on('seeked', function () {});
      // this.player.on('ratechange', function () {});
      _this.player.on('timeupdate', function () {
        _this.timeupdate();
      });
      // this.player.on('volumechange', function () {});
      // this.player.on('stalled', function () {});
    },
    //获取验证码
    getTmVerCode(time) {
      this.codeResTime = time;
      let query = {
        playTime: time.toString(),
        configKey: this.configKey
      };
      getTmVerCode(query).then(res => {
        let result = JSON.parse(res.data.data.data);

        if (result.result == '200') {
          if (result.data.couldAnswerCount == -1 || (result.data.couldAnswerCount != -1 && result.data.remainAnswerCount > 0)) {
            this.codeImg = 'data:image/jpeg;base64,' + result.data.content;
            this.codeId = result.data.id;
            this.dialogVisible = true;
            this.player.pause();
          } else {
            this.getTmVerCode(this.codeResTime + this.getVerCodeTime * 60);
          }
        }
        if (result.result == '505') {
          this.player.play();
          return false;
        }

        if (result.result == '500' || result.data.result == '503') {
          this.$message('无权限，请联系管理员！');
          this.$router.back();
          return false;
        }

        if (result.result == '506') {
          this.codeStatus = true;
          //当前节点时间验证过了,验证下一个时间
          this.getTmVerCode(this.codeResTime + this.getVerCodeTime * 60);
          this.player.play();
          return false;
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      this.getData(2);
    } else {
      this.getData(1);
    }

    this.toAllReadyBuy()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener(
      'storage',
      () => {
        window.open('about:blank', '_self');
        window.close();
      },
      false
    );
    localStorage.setItem('Sentinel', Math.random());

    this.timer = setInterval(() => {
      this.updateDBTrack();
    }, 4 * 60 * 1000);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeDestroy() {
    this.updateDBTrack();
    clearInterval(this.timer);
    // if (this.player) {
    //   this.player.destroy(); //重置videojs的内部状态并移除dom
    // }
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.mrw16 {
  width: 16px;
  height: 16px;
  margin-top: 14px;
}
@media (max-width: 768px) {
  .goStudy {
    position: absolute;
    z-index: 99;
    color: #fff;
    right: 15px;
    top: 7px;
    width: 100px;
    height: 32px;
    cursor: pointer;
    font-size: 13px;
    background: #438ce7;
    text-align: center;
    line-height: 32px;
    border-radius: 32px;
  }
  .phoneHead {
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    font-family: Medium;
    .back {
      width: 50px;
      img {
        width: 25px;
        height: 25px;
      }
    }
    .texs {
      font-size: 17px;
    }
  }
  .videoBanner {
    display: none;
  }
  .videoHeader {
    display: none;
  }

  .bannerBox {
    display: none;
  }

  .phoneBanner {
    font-family: Medium;
    padding-bottom: 160px;
    .videobox {
      width: 100% !important;
      height: 255px !important;
    }

    .chapterName {
      width: 100%;
      padding: 15px;
      font-size: 18px;
      color: #333;
      .t_1 {
        margin-top: 9px;
        font-size: 15px;
        color: #666666;
        font-family: Regular;
      }
    }

    .bgc {
      width: 100%;
      height: 10px;
      background: #f5f5f9;
    }

    .chapterList {
      padding: 0 15px;
    }
    .tabBox {
      display: flex;
      font-size: 16px;
      margin-top: 29px;
      font-family: Regular;
      color: #333333;
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 20px;
      .to {
        padding-bottom: 9px;
      }
      .xu {
        margin-left: 30px;
      }
      .active {
        color: #2878ff;
        border-bottom: 1px solid #2878ff;
      }
    }

    .chapterActive {
      border: 1px solid #156de8 !important;
    }
    .chapter {
      width: 100%;
      background: #f5f5f9;
      padding: 15px;
      position: relative;
      border-radius: 6px;
      margin-bottom: 10px;
      border: 1px solid #fff;

      .rightStatus {
        position: absolute;
        right: 0;
        top: 0;
        width: 65px;
        height: 24px;
        background: rgba(255, 128, 0, 0.15);
        border-radius: 0px 6px 0px 26px;
        text-align: center;
        line-height: 24px;
        font-size: 13px;
        color: #ff8000;
        font-family: Medium;
      }
      .chaptList {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
      }
      .cwName {
        width: 195px;
      }
      .titleText {
        margin-top: 24px;
        font-size: 16px;
        color: #333333;
        font-family: Medium;
      }
      .botBox {
        margin-top: 11px;
        display: flex;
        justify-content: space-between;
        .xue {
          margin-top: 6px;
          font-family: Regular;
          color: #666666;
          font-size: 14px;
        }
        .xueBtn {
          width: 75px;
          height: 32px;
          border: 1px solid #2878ff;
          opacity: 1;
          border-radius: 18px;
          color: #2878ff;
          font-size: 14px;
          text-align: center;
          line-height: 32px;
        }
      }
    }

    .xuzhi {
      font-family: Regular;
      font-size: 15px;
      color: #666;
    }
  }
}

@media (min-width: 768px) {
  .fs18 {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
  }
  .phoneHead {
    display: none;
  }
  .phoneBanner {
    display: none;
  }
  .videoHeader {
    height: 60px;
    background: #1c2127;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.27);
    opacity: 1;
    border-radius: 0px;
    padding: 15px 30px;
    display: flex;
    .backBox {
      width: 130px;
      height: 30px;
      background: #438ce7;
      opacity: 1;
      border-radius: 15px;
      font-size: 14px;
      color: #fff;
      display: flex;
      align-items: center;
      padding-left: 19px;
      cursor: pointer;
      img {
        width: 15px;
        height: 15px;
      }
      .back_text {
        margin-left: 8px;
        font-size: 14px;
      }
    }
    .courseText {
      margin-left: 12px;
      color: #fff;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .bannerBox {
    padding: 0 0 0 30px;
    display: flex;
    background: #000000;
    .videoBox {
      margin-top: 20px !important;
      width: 1460px !important;
      height: 630px !important;
      opacity: 1;
      border-radius: 0px;
    }

    .tips {
      margin-top: 20px;
      width: 789px;
      background: #1c2127;
      padding: 20px 30px;
      color: #bfc5c9;
      font-size: 14px;
      .tipsTitle {
        font-size: 18px;
        position: relative;
        z-index: 2;
        div {
          position: absolute;
          width: 64px;
          height: 6px;
          background: linear-gradient(270deg, rgba(21, 109, 232, 0) 0%, #156de8 100%);
          opacity: 1;
          border-radius: 0px;
          bottom: 3px;
          z-index: -1;
        }
      }
      .margin25 {
        margin-top: 8px;
      }
    }
    .tipsShow {
      width: 1460px !important;
    }
    .bm {
      margin-top: 20px;
      width: 656px;
      background: #1c2127;
      margin-left: 10px;
      padding: 20px 30px 20px 20px;
      .b1 {
        font-size: 18px;
        color: #bfc5c9;
      }
      .b2 {
        font-size: 16px;
        margin-top: 16px;
        color: #bfc5c9;
      }
      .b3 {
        display: flex;
        justify-content: space-between;
        margin-top: 26px;
        .b4 {
          width: 120px;
          height: 40px;
          border-radius: 20px 20px 20px 20px;
          border: 1px solid #bfc5c9;
          color: #bfc5c9;
          font-size: 14px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
        }
      }
    }
    .directory::-webkit-scrollbar {
      width: 5px; //修改滚动条宽度
    }
    .directory::-webkit-scrollbar-thumb {
      border-radius: 8px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #666666;
    }
    //鼠标移入样式
    .directory::-webkit-scrollbar-thumb:hover {
      background: #333333;
    }

    .directory {
      width: 511px;
      height: 880px;
      overflow-y: scroll;
      overflow-x: hidden;
      background: #1c2127;
      margin-left: 20px;
      padding: 0px 20px;
      color: #bfc5c9;
      font-size: 14px;

      .tipsTitle {
        font-size: 16px;
        position: relative;
        z-index: 2;
        margin-bottom: 10px;
        div {
          position: absolute;
          width: 64px;
          height: 6px;
          background: linear-gradient(270deg, rgba(21, 109, 232, 0) 0%, #156de8 100%);
          opacity: 1;
          border-radius: 0px;
          bottom: 3px;
          z-index: -1;
        }
      }
      .listBox_1 {
        margin-top: 20px;
        // width: 430px;
        height: 44px;
        background: rgba(255, 255, 255, 0.2);
        color: #bfc5c9;
        padding: 0 15px;
        line-height: 44px;
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        .ml8 {
          width: 368px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-left: 8px;
        }
        .mar38 {
          margin-left: 20px;
          margin-right: 0px;
        }
        .sColor {
          color: #4076f6;
        }
        .play {
          width: 66px;
          height: 24px;
          background: #4076f6;
          opacity: 1;
          border-radius: 12px;
          text-align: center;
          line-height: 24px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
